import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { Avatar } from '@mui/material';
const Image = ({ url, status, alt, className, avatar, avatarVariant, customStyle, backgroundColor, fallbackSrc, updatedAt, }) => {
    if (url) {
        if (avatar) {
            return (_jsx(Avatar, { src: url || fallbackSrc, variant: avatarVariant, alt: alt, sx: {
                    backgroundColor: url ? 'inherit' : backgroundColor,
                    ...customStyle,
                } }));
        }
        return (_jsx("img", { src: url || fallbackSrc, alt: alt, className: className, style: {
                backgroundColor: url ? 'inherit' : backgroundColor,
                ...customStyle,
            } }));
    }
    return null;
};
Image.defaultProps = {
    className: '',
    avatar: false,
    customStyle: {},
    avatarVariant: 'circular',
    backgroundColor: '#444444',
    fallbackSrc: undefined,
    updatedAt: undefined,
};
export default observer(Image);
//# sourceMappingURL=Image.js.map